module.exports = __webpack_public_path__ + "static/img/medica.b13d042.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medica.png
// module id = XoeB
// module chunks = 0